import { FC } from 'react';

import classNames from 'classnames';
import styled from '@emotion/styled';
import { PaymentItem as PaymentItemModel } from 'store/my-registrations/types';
import { ReadonlyField } from 'components';
import { formatDate, formatUTCDate } from 'core';

import { Card, Quote } from '@britishcouncil/react-solas-ors3';
import { getTaxInfo } from 'pages/helper/taxInfo';

export const PaymentItem: FC<{ payment: PaymentItemModel }> = ({ payment }) => {
  const paid = payment.balance >= 0;
  const taxInfo = getTaxInfo(payment.taxRate, payment.amount);
  return (
    <StyledCard className={classNames({ success: paid, danger: !paid })}>
      <span className={classNames('label', { 'label-success': paid, 'label-danger': !paid })}>
        {paid ? 'Paid' : 'Unpaid'}
      </span>
      <StyledReadonlyField label="Date">{formatDate(payment.transactionDate)}</StyledReadonlyField>
      <StyledReadonlyField label="Registration action">{payment.registrationEventTypeName}</StyledReadonlyField>
      <StyledReadonlyField label="Payment method">{payment.paymentName}</StyledReadonlyField>
      <StyledReadonlyField label="Reference">{payment.transactionReference}</StyledReadonlyField>
      <StyledReadonlyField label="Amount">
        {payment.amount.toFixed(2)} {payment.currencyCode} {taxInfo}
      </StyledReadonlyField>
      {payment.balance < 0 && (
        <Quote title="" intent="info">
          This fee{' '}
          <strong>
            {-payment.balance.toFixed(2)} {payment.currencyCode}
          </strong>{' '}
          is valid up to and including <strong>{formatUTCDate(payment.sessionMilestone)} (GMT/BST)</strong> after
          which additional/late fees will be charged.
        </Quote>
      )}
      {payment.balance > 0 && (
        <Quote title="" intent="info">
          {payment.registrationEventTypeName === 'Cancelled'
            ? 'Refund is being processed'
            : 'Payment is being processed'}
        </Quote>
      )}
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  position: relative;
  &.success {
    border: 1px solid #3d9026;
    border-left: 5px solid #3d9026;
  }
  &.danger {
    border: 1px solid #cb2210;
    border-left: 5px solid #cb2210;
  }
  .label {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .form-group {
    margin-bottom: 5px;
  }
`;

const StyledReadonlyField = styled(ReadonlyField)`
  dt {
    width: 200px;
  }
`;
